import { render } from "./subSummary.vue?vue&type=template&id=4795a4f3"
import script from "./subSummary.vue?vue&type=script&lang=js"
export * from "./subSummary.vue?vue&type=script&lang=js"

import "./subSummary.vue?vue&type=style&index=0&id=4795a4f3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__